<template>
  <div class="template" v-if="newAllBetEvent.od[plytyp]">
    <template v-for="btype in btypes" v-if="newAllBetEvent.od[plytyp][btype]">
      <div data-template="template1" class="wrap-template template1">
        <div class="main-handicap">
          <div class="vrow items-center template-title is_fold">
            <div class="play-name col" @click="showLeg()">
              <span class="ellipsis">{{ getTitleCaption() }}{{ sportAllBetLang['ALL_BET.SUBHEADER_DBCH'] }}</span>
            </div>
            <div style="width: 37px;" @click="setToTop($event)">
              <span class="set_top" style="display: none;">
                <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
              </span>
            </div>
          </div>
          <template v-if="show">
            <div class="handicap m-1x2">
              <div class="handicap-item os-1 no_border_bottom">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:75%">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap"></span>
                          <span class="ellipsis-wrap">{{ getTeamLabel('hd') }}</span>
                        </div>
                      </div>
                    </div>
                    <oddDbch :event="newAllBetEvent" :team="'hd'" :plyType="plytyp" :betType="btype" ref="hd" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item os-1 no_border_bottom">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:75%">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap"></span>
                          <span class="ellipsis-wrap">{{ getTeamLabel('ha') }}</span>
                        </div>
                      </div>
                    </div>
                    <oddDbch :event="newAllBetEvent" :team="'ha'" :plyType="plytyp" :betType="btype" ref="ha" :mode="'ab'" />
                  </div>
                </div>
              </div>
              <div class="handicap-item os-1 no_border_bottom">
                <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                  <div class="bet-inner yb-flex-center fit">
                    <div class="handicap-wrap">
                      <div class="bet-item" style="width:75%">
                        <div class="item-label bet-ellipsis ellipsis">
                          <span class="ellipsis-wrap"></span>
                          <span class="ellipsis-wrap">{{ getTeamLabel('ad') }}</span>
                        </div>
                      </div>
                    </div>
                    <oddDbch :event="newAllBetEvent" :team="'ad'" :plyType="plytyp" :betType="btype" ref="ad" :mode="'ab'" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import OddDBCHComponents from '../../../components/odd-dbch'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null
  },
  data() {
    return {
      btypes: [allBetMixin.data().dbchBetType, allBetMixin.data().rdbchBetType],
      show: true,
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    }
  },
  watch: {
    foldopenAllBet() {
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }
    },
    foldopenFirstEvent() {
      if(this.mode!='ab'){
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption() {
      var a = 'FT'
      var b = ''
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H'
      }else if (this.plytyp == this.SecondHtPlyType) {
        a = '2H'
      }

      // if (this.bettype == this.hdpBetType) {
      a =   this.sportAllBetLang['ALL_BET.SUBHEADER_' + a] ;
     // b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_HDP']
      // } else if (this.bettype == this.bttsBetType) {
      //   b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_BTTS']
      // }


      return a
    },
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    setToTop(e) {
      this.$parent.setToTop(e);
    },
    getTeamLabel(team) {
      // var or = this.sportAllBetLang['ALL_BET.LBL_OR']
      if (team == 'ha') {
        return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] 
        // return this.newAllBetEvent.tacapt + or + this.newAllBetEvent.tbcapt
      } else if (team == 'ad') {
        return this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW']
        // return this.newAllBetEvent.tbcapt + or + this.sportAllBetLang['ALL_BET.LBL_DRAW']
      } else if (team == 'hd') {
        return this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW']
        // return this.newAllBetEvent.tacapt + or + this.sportAllBetLang['ALL_BET.LBL_DRAW']
      }
    },
    addToMyMarket(plytyp, onex2BetType) {
      if (this.selectMarket)
        this.selectMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial)
    },
    removeFromMyMarket(plytyp, onex2BetType) {
      if (this.removeMarket)
        this.removeMarket(this.allBetEvent, plytyp, onex2BetType, this.isSpecial)
    },
    // oddsHeader(onex2BetType) {
    //   var retCapt = ''
    //   if (this.isSpecial) {
    //     retCapt += this.specialLeagueCaption(this.allBetEvent, onex2BetType)
    //   }
    //   return retCapt
    // },
  },
  mounted(){
    if(this.mode=='ab'){
      this.show = (this.$store.getters.foldopenAllBet) ? true : false;
    }else{
      this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-dbch.vue